import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBluetooth: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bluetooth"><path d="M11.8611 12L16.75 8L10.75 3V11.0909M11.8611 12L10.75 12.9091M11.8611 12L16.75 16L10.75 21V12.9091M11.8611 12L10.75 11.0909M10.75 12.9091L5.75 17M10.75 12.9091V11.0909M10.75 11.0909L5.75 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBluetooth;
